import React from "react";
import { Link } from "react-router-dom";
import logo from "./logo.png";
import "./style.css";

const Footer = () => {
  return (
    <footer className="page-footer">
      <div className="container">
        <div className="footer-top">
          <img src={logo} alt="BGV Cinema" className="footer-logo" />
        </div>

        <div className="footer-bottom">
          <div className="row">
            <div className="quick-link-list">
              <ul>
                <li>
                  <Link to="/faq">FAQ</Link>
                </li>
                <li>
                  <Link to="/help">Help Center</Link>
                </li>
                <li>
                  <Link to="/terms">Terms of Use</Link>
                </li>
                <li>
                  <Link to="/privacy">Privacy</Link>
                </li>
              </ul>
            </div>

            <div className="footer-social">
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/BGVCinemaOfficial"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="ri-facebook-fill"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/BGVCinema"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="ri-twitter-fill"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/BGVCinema"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="ri-instagram-fill"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/BGVCinemaChannel"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="ri-youtube-fill"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright">
        <div className="container">
          <p className="para">
            &copy; {new Date().getFullYear()} BGV Cinema. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
